<template>
  <v-dialog v-model="value" width="600" @keydown.esc="dismiss()" persistent scrollable>
    <v-card class="mt-5">
      <v-card-title class="pb-0 flex justify-space-between">
        <div v-if="title">{{title}}</div>
        <div v-else>{{ $t('market.select_market_to_add') }}</div>
        <div>
          <v-btn
            color="success"
            small
            text
            @click="selectAll()"
          >{{ $t('select_all') }}</v-btn>
          <v-btn
            color="error"
            small
            text
            @click="unSelectAll()"
          >{{ $t('un_select') }}</v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <template v-if="markets && markets.length && !isLoading">
          <v-checkbox
            v-for="market in markets"
            v-model="marketIds"
            :key="market.objectId"
            hide-details
            :value="market.objectId"
            :label="`${market.name}`"
          ></v-checkbox>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" @click="dismiss()">{{ $t('close') }}</v-btn>
        <v-btn :color="btnType ? btnType : 'success'" @click="submit()">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    markets: Array,
    title: String,
    btnType: String
  },
  data() {
    return {
      hashMarket: null,
      isLoading: false,
      marketIds: []
    };
  },
  watch:{
    value(val){
      if(val) this.resetData()
    },
  },
  created() {
    this.resetData()
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    submit(){
      this.$emit("onSuccess", this.marketIds);
      this.dismiss()
    },
    selectAll(){
      this.marketIds = this.markets.map(d => d.objectId)
    },
    unSelectAll(){
      this.marketIds = []
    },
    resetData(){
      this.marketIds = []
    }
  }
};
</script>
